<template>
    <actions-layout>
        <common-page-header :heading="heading" :content="content" contentSpacing="medium"></common-page-header>

        <common-content-wrapper width="large">
            <!-- <import-contacts
                :sendButtonLabel="$t('pages.auth.invite_member.buttons.collect_contacts')"
                :showSearchBar="true"
                @contacts-emails-collected="collectContactsEmails"
            ></import-contacts> -->
            <email-collector
                label="Member"
                placeholder="membername@email.com"
                buttonLabel="send invite"
                :initialNumOfFields="initialNumOfFields"
                :formData="formDataEmailFields"
                :valuePath="'emailFields'"
                @emails-collected="emailsCollected"
                @change="emailsChanged"
            ></email-collector>
            <common-modal
                v-if="showEmailsCheckModal"
                :width="'medium'"
                @emitEvent="emitEvent($event, ['close'])"
                @close="emitEvent({ name: 'close' })"
            >
                <send-join-invites-overview
                    :emailsCheck="emailsCheck"
                    :practiceType="$t('pages.auth.invite_member.constants.practice_type')"
                    :defaultCloseButtonEnabled="false"
                    :innerButtonsProperties="determineModalButtons"
                    @new-email-invitations-present="sendInvitationsToOtherMembers"
                    @invite-more-members="clearEmailFormFields"
                    @go-to-select-physician="goToSelectPhysicianPage"
                    @log-out-user="logOutUser"
                    @close="checkInviteEmailsModalClosedHandler"
                ></send-join-invites-overview>
            </common-modal>
            <portal-target name="modals"></portal-target>
        </common-content-wrapper>
    </actions-layout>
</template>

<script>
    import AuthService from 'services/AuthService'
    import Router from '~/router'
    import UsersAPI from '../../api/UsersAPI'
    import PageWithTitleMixin from 'mixins/PageWithTitleMixin'
    import ActionsLayout from 'components/layouts/ActionsLayout'
    import EmailCollector from 'components/page-elements/network/EmailCollector'
    import SendJoinInvitesOverview from 'components/page-elements/invites/SendJoinInvitesOverview'
    import InvitationEmailCheckModalMixin from '../../mixins/InvitationEmailCheckModalMixin'

    export default {
        mixins: [PageWithTitleMixin, InvitationEmailCheckModalMixin],

        components: {
            ActionsLayout,
            EmailCollector,
            SendJoinInvitesOverview,
        },

        data() {
            return {
                practiceType: this.$t('pages.auth.invite_member.constants.practice_type'),
            }
        },

        computed: {
            pageTitle() {
                return this.$t('pages.auth.invite_member.title')
            },
            heading() {
                return this.$t('pages.auth.invite_member.heading1', {
                    firstName: this.$auth.getUser().firstName,
                    lastName: this.$auth.getUser().lastName,
                })
            },
            content() {
                return this.$t('pages.auth.invite_member.content1', { practiceName: this.$auth.getPractice().name })
            },
            determineModalButtons() {
                const buttons = [
                    {
                        label: this.$t('pages.auth.invite_member.buttons.invite_others'),
                        type: 'white-with-border',
                        size: 'large',
                        isSubmittable: false,
                        eventName: 'invite-more-members',
                    },
                ]
                const members = this.$auth.getMembers()
                if (members.length > 1 && members.some(({ userRole }) => userRole && userRole.id === 1)) {
                    buttons.push({
                        label: this.$t('pages.auth.invite_member.buttons.show_my_physicians'),
                        type: 'primary',
                        size: 'large',
                        isSubmittable: false,
                        eventName: 'go-to-select-physician',
                    })
                } else {
                    buttons.push({
                        label: this.$t('pages.auth.invite_member.buttons.log_out'),
                        type: 'primary',
                        size: 'large',
                        isSubmittable: false,
                        eventName: 'log-out-user',
                    })
                }
                return buttons
            },
        },

        methods: {
            collectContactsEmails(conctactsEmails) {
                conctactsEmails.forEach((item) => {
                    item.emails.forEach((el) => {
                        this.sourceEmailFields.push({
                            email: el.email,
                            firstName: item.firstName,
                            lastName: item.lastName,
                        })
                    })
                })
                this.sourceEmailFields = this.sourceEmailFields.filter((emailFieds) => emailFieds.email !== '')
            },
            goToSelectPhysicianPage() {
                return Router.push({ name: 'auth.select-physician' })
            },
            logOutUser() {
                AuthService.logOut()
                if (process.env.VUE_APP_ENV === 'development') {
                    this.$router.push({ name: 'auth.login' })
                } else {
                    window.location.href = process.env.VUE_APP_WP_URL
                }
            },
            sendInvitationsToOtherMembers(event) {
                UsersAPI.createJoinPracticeInvites({
                    userId: this.$auth.getActiveMember().id,
                    emails: event.emails,
                    practiceId: this.$auth.getPractice().id,
                })
                    .then(() => {})
                    .catch((error) => {
                        this.showJoinInvitesErrorMessageCode = error.response.data[0].code
                        this.showJoinInvitesErrorModal = true
                    })
            },
        },

        mounted() {
            this.clearEmailFormFields()
        },
    }
</script>
